import { ArrowRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { MarketingTrackedLink } from "@/components/site/primitives/marketing-tracked-link";
import { buildComparisonManualHref, buildComparisonTrialHref, type ComparisonAudience, type ComparisonSlug } from "@/lib/comparison-links";

type ComparisonCtaProps = {
  slug: ComparisonSlug;
  audience: ComparisonAudience;
  placement: "hero" | "example" | "pricing" | "closing" | "manual_bridge";
  manual?: boolean;
  label?: string;
  secondary?: boolean;
};

export function ComparisonCta({ slug, audience, placement, manual = false, label, secondary = false }: ComparisonCtaProps) {
  const destination = manual ? "manual" : "trial";
  const properties = {
    comparison_slug: slug,
    audience,
    placement,
    destination,
    app_area: "compare",
    route_name: "compare.detail",
    cta_id: `compare_${slug}_${placement}`,
  };

  return (
    <Button asChild size="lg" variant={secondary ? "outline" : "default"} className="h-auto min-h-11 whitespace-normal rounded-xl px-5 py-3 text-base">
      <MarketingTrackedLink
        href={manual ? buildComparisonManualHref(slug) : buildComparisonTrialHref(slug, placement)}
        preserveCampaignParams={manual}
        eventName="comparison_cta_clicked"
        eventProperties={properties}
        additionalEvents={manual ? [] : [{ eventName: "trial_cta_clicked", eventProperties: properties }]}
      >
        {label ?? (manual ? "Create my manual" : "Start free trial")}
        <ArrowRight className="ml-3 size-4 shrink-0" aria-hidden="true" />
      </MarketingTrackedLink>
    </Button>
  );
}
